// NewKBRecordCallModal-leadDataManagement.js
import api from '../../../../services/api'; // Ensure this path is correct for your project structure

/**
 * Fetches the call history for a given lead.
 * @param {object} lead - The lead object.
 * @param {function} toast - The Chakra UI toast function.
 * @param {function} setCallHistory - State setter for call history.
 * @param {function} setIsLoadingHistory - State setter for loading state of call history.
 */
export const fetchLeadCallHistory = async (lead, toast, setCallHistory, setIsLoadingHistory) => {
  if (!lead?.leadId && !lead?._id) {
    setCallHistory([]);
    if (typeof setIsLoadingHistory === 'function') {
        setIsLoadingHistory(false);
    }
    return;
  }

  if (typeof setIsLoadingHistory === 'function') {
    setIsLoadingHistory(true);
  }
  try {
    const leadId = lead.leadId || lead._id;
    // To ensure all call logs are fetched, we add a high limit. The backend defaults to 10 otherwise.
    const response = await api.get(`/api/call-logs/lead/${leadId}?limit=100`);
    setCallHistory(response.data.callLogs || []);
  } catch (error) {
    console.error('[NewKBRecordCallModal-leadDataManagement] Error fetching call history:', error);
    toast({
      title: 'Error fetching call history',
      description: 'Could not load previous call logs',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
  } finally {
    if (typeof setIsLoadingHistory === 'function') {
        setIsLoadingHistory(false);
    }
  }
};

/**
 * Saves customer notes for a given lead.
 * @param {string} notesToSave - The notes to be saved.
 * @param {object} lead - The lead object.
 * @param {function} toast - The Chakra UI toast function.
 * @param {function} setCustomerNotesState - State setter for customer notes in the modal.
 * @param {function} onSuccessCallback - Callback function to execute on successful save, passing updated lead.
 */
export const saveLeadCustomerNotes = async (notesToSave, lead, toast, setCustomerNotesState, onSuccessCallback) => {
  if (!lead?.leadId && !lead?._id) {
    toast({
        title: 'Lead not found',
        description: 'Cannot save notes without a valid lead.',
        status: 'error',
        duration: 3000,
        isClosable: true,
    });
    return;
  }

  try {
    const leadId = lead.leadId || lead._id;
    await api.put(`/api/leads/${leadId}`, { customerNotes: notesToSave });

    toast({
      title: 'Notes saved',
      status: 'success',
      duration: 2000,
      isClosable: true,
    });

    if (typeof setCustomerNotesState === 'function') {
        setCustomerNotesState(notesToSave);
    }

    if (typeof onSuccessCallback === 'function') {
      const updatedLead = {
        ...lead,
        customerNotes: notesToSave,
      };
      // The original component passed (updatedLead, { notes: notesToSave })
      onSuccessCallback(updatedLead, { notes: notesToSave });
    }
  } catch (error) {
    console.error('[NewKBRecordCallModal-leadDataManagement] Error saving customer notes:', error);
    toast({
      title: 'Error saving notes',
      description: error.response?.data?.message || 'Could not save customer notes.',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
  }
};